import BaseApi from '../base/base'
import Infor from '../../models/information'

export default class InforApi extends BaseApi {
  constructor() {
    super()
    this.path = '/infors'
  }

  async index(page: number = 0): Promise<Infor[]> {
    this.path = '/infors'
    const response = await this.getRequest({
      page
    })
    return response.data.map((element) => new Infor(element))
  }

  async show(inforId: string, params = {}) {
    this.path = `/infors/${inforId}`
    const response = await this.getRequest(params)
    return new Infor(response.data)
  }

  async readAll(params = {}) {
    this.path = `/infors/readall`
    await this.postRequest(params)
    return true
  }

  async unread(inforId: string, params = {}) {
    this.path = `/infors/${inforId}/unread`
    const response = await this.postRequest(params)
    return new Infor(response.data)
  }
}
